import { inject } from "@angular/core";
import { AuthService, MemberQuery } from "@fgb/core";
import { Populations } from "src/app/shared/utilities/populations";

export const canMatchKids = () => {
    const authService = inject(AuthService);
    
    if( authService.isAuthenticated() ){
        const memberQuery = inject(MemberQuery);

        let memberPopulation = memberQuery.getPopulationName();
        if (memberPopulation && [Populations.Kids].includes(memberPopulation)) {
            return true;
        }

    }
        
    return false;
}